// wood-drag.js

window.WOOD_DRAG = (() => {

  function enable(el, container) {

    if (!el || !container) return;

    if (el.dataset.dragReady === "true") return;

    el.dataset.dragReady = "true";

    let isDragging = false;

    let startX = 0;
    let startY = 0;

    let initialLeft = 0;
    let initialTop = 0;

    el.style.position = "absolute";
    el.style.touchAction = "none";
    el.style.userSelect = "none";

    function pointerMove(e) {

      if (!isDragging) return;

      const dx = e.clientX - startX;
      const dy = e.clientY - startY;

      let newLeft = initialLeft + dx;
      let newTop = initialTop + dy;

      const maxLeft =
        container.clientWidth - el.offsetWidth;

      const maxTop =
        container.clientHeight - el.offsetHeight;

      newLeft = Math.max(
        0,
        Math.min(newLeft, maxLeft)
      );

      newTop = Math.max(
        0,
        Math.min(newTop, maxTop)
      );

      el.style.left = `${newLeft}px`;
      el.style.top = `${newTop}px`;
    }

    function stopDragging() {

  isDragging = false;

  document.removeEventListener(
    "pointermove",
    pointerMove
  );

  document.removeEventListener(
    "pointerup",
    stopDragging
  );

  window.WOODStorage?.save();
}

    el.addEventListener("pointerdown", function(e) {

      if (el.contentEditable === "true") return;

      isDragging = true;

      startX = e.clientX;
      startY = e.clientY;

      initialLeft =
        parseFloat(el.style.left) || 0;

      initialTop =
        parseFloat(el.style.top) || 0;

      document.addEventListener(
        "pointermove",
        pointerMove
      );

      document.addEventListener(
        "pointerup",
        stopDragging
      );
    });
  }

  return {
    enable
  };

})();